import { render, staticRenderFns } from "./MyOrdersList.vue?vue&type=template&id=4f81fd17&scoped=true"
import script from "./MyOrdersList.vue?vue&type=script&lang=js"
export * from "./MyOrdersList.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersList.vue?vue&type=style&index=0&id=4f81fd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81fd17",
  null
  
)

export default component.exports